<template>
  <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
    <template v-slot:activator="{ on }">
      <v-btn icon width="10px">
        <v-icon v-on="on">filter_list</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-toolbar dark color="transparent" class="elevation-0">
        <v-btn icon dark @click="dialog = false">
          <v-icon color="#099AB1">keyboard_arrow_left</v-icon>
        </v-btn>
        <v-layout>
          <v-flex xs11 class="d-flex justify-center">
            <v-toolbar-title class="cyan--text text--darken-2">Filtrar</v-toolbar-title>
          </v-flex>
        </v-layout>
      </v-toolbar>

      <v-list>
        <v-list-group v-for="item in items" :key="item.title" v-model="item.active" no-action>
          <template v-slot:activator>
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>

          <v-list-tile v-for="subItem in item.items" :key="subItem" @click="">
            <v-list-tile-content>
              <v-list-tile-title>{{ subItem }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>
      </v-list>

      <v-card-actions class="justify-center my-4">
        <v-btn
          block
          x-large
          depressed
          dark
          class="text-uppercase"
          color="#099AB1"
          to="/catalogo"
          @click="dialog = false"
        >
          Aplicar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    filters: Object,
  },
  mounted() {
    this.items.push({
      title: 'Categoria',
      items: this.filters.categories,
    });

    this.items.push({
      title: 'Numeração',
      items: this.filters.sizes,
    });

    this.items.push({
      title: 'Cor',
      items: this.filters.colors,
    });
  },
  data: () => ({
    dialog: false,

    items: [],
  }),
};
</script>
